<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-gray-800 text-xl font-bold">{{$t('settings')}}</h6>
        <button @click="save" class="rouanded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300" type="button">{{$t('Save settings')}}</button>
      </div>
    </div>

    <div class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{$t('Employeurs concernant')}} ({{ idWharhouse.name }})</h6>
        <div class="flex flex-wrap">
          <div class="w-full">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{$t('Employeurs')}}</label>
               <v-select  @input="setRoles"  v-model="formData.employers" :options="roles" multiple class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"></v-select>
            </div>
          </div>
        </div>
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{$t('Paramétrages')}}</h6>
        <div v-if="formData.detail.salaries && formData.detail.salaries.length>0" class="relative">
            
            <!------------------------------------------------>
            <tabs :options="{ defaultTabHash: defaultTabHash }">
              
              <tab  v-for="(pr, key) in formData.detail.salaries" :key="key" :id="'tab_'+pr.type" :name="pr.type" style="padding: 1.5em 1em !important;">
              
                  <div class="grid lg:grid-cols-3 gap-6"> 
                      <div class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Salaire de base')}} (1 mois <small v-if="pr.nbDays">({{pr.nbDays}} Jours)</small>) <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.salary"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>

                      <div class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Nombre de jours par mois')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> Jours</span></div>
                          <input type="number" v-model="pr.nbDays"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>

                      <div class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Prime 1 mois du travaille')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.prime"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>
                  </div>

                  <!-- <div class="grid lg:grid-cols-2 gap-6 mt-8">
                    <div class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Montant absent (1/2 Journée)')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.absentAmount"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>
                  </div> -->

                  <div v-if="['Courier','TeleConsultant'].includes(pr.type)" class="grid lg:grid-cols-3 gap-6 mt-8"> 
                      <div v-if="pr.type === 'TeleConsultant'" class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Prime 1 order confirmed')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.confirmed"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>

                      <div v-if="['Courier','TeleConsultant'].includes(pr.type)" class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Prime 1 order delivred')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.delivered"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>
                      <div v-if="pr.type === 'TeleConsultant'" class="border hover:border-green-500  border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{$t('Prime 1 Upsell delivred')}} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-500 w-1/4 bg-gray-200"><span> {{ idWharhouse.currency }}</span></div>
                          <input type="number" v-model="pr.upsell"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      </div>
                  </div>
                 
              </tab>
            
            </tabs>
            <!---------------------------------------------------->

        </div>

        

    </div>
  
    <div class="pt-3 flex btn-bottom-toolbar justify-end">
      <button @click="save" class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"> {{$t('Save settings')}} </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
   },
  data() {
    return {
      formData: {
        details:[],
        dataUser:[],
        detailSeller:{
          open_colis:false,
          confirmation:false,
          fulfillement:false,
          shipping:false,
        },
         detail:{
          shipping: {fees: 0,},
          order: {
            feesConfirmation: 0,
            fulfillement_fees: 0,
          },
          quality_control:0, 
          phone:null,email:null,
          info: {mad: 1,currency: 1,currencyCredit: 1,},
      },
        tva:[],
        blacklist_phones:[],
        sms:{active:false,roles:[]},
        employers:[]
      },
      detail:{
          shipping: {
          fees: 0,
          },
          order: {
            feesConfirmation: 0,
            fulfillement_fees: 0,
          },
          quality_control:0,
          phone:null,email:null,
          info: {mad: 1,currency: 1,currencyCredit: 1},
      },
      detailSeller:{
         open_colis:false,
         confirmation:false,
         fulfillement:false,
         shipping:false,
      },
      loading:false,
      fullPage: false,
      options:this.$countries,
      roles:[],
      defaultTabHash:''
    };
  },

  async mounted() {
     await this.getSettings();
  },
  computed: {
    warhouseSelected(){
       return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
    },
  },
   watch: {
      'warhouseSelected': async function(oldVal, newVal) {
          await this.getSettings();
      },
  },
  methods: {
    setRoles(data){
      console.log('data---',data)
     

       if(this.formData.employers && this.formData.employers.length>0){
            this.formData.employers.forEach(elem => {
               const chekUserExist=this.formData.detail.salaries.find(item=> item.type === elem);
               if(!chekUserExist) this.formData.detail.salaries.push({type:elem,salary:0,absentAmount:0}); 
            });

            this.formData.detail.salaries.forEach(elem => {
               const chekUserExist=this.formData.employers.find(item=> item === elem.type);
               if(!chekUserExist) this.formData.detail.salaries = this.formData.detail.salaries.filter(function( obj ) {return obj.type !== elem.type;});
            });

            this.defaultTabHash='tab_'+this.formData.detail.salaries[this.formData.detail.salaries.length-1].type;
            window.history.replaceState({}, '', location.pathname);
            location.hash = "#" + this.defaultTabHash;
       }else {this.formData.detail.salaries=[];this.defaultTabHash=''}

    },
    trigger() {
      this.$refs.sendReply.click();
    },
    async getRoles() {
      if(this.roles.length === 0){
          const res = await this.$server.search("roles",{limit:100});
          if (res && res.content.results) {
              this.roles = res.content.results.filter(e=> e.type !== 'Autre').map(el=> el.type);
          } else this.roles = [];
      }
    },
     getElementInArray(data,value){
        var result  = data.filter(function(o){
            let whar=o.warehouse;
            if(o.warehouse._id) whar=o.warehouse._id;
            return whar == value.toString();
        } );
        return result? result[0] : null; // or undefined
    },

    async save() {
         const {content:dataWahrhouse} = await this.$server.get("settings",{warehouse:this.idWharhouse._id});

          if(dataWahrhouse.length === 0){
            alert('Settings not Fount', "warning");
            return false;
          } 

          this.formData.action="Salaries";
          this.formData.detail.warehouse=this.idWharhouse._id;
          this.formData.detail.country=this.idWharhouse.country;
          this.loading=true;
          const data = await this.$server.update("settings", this.formData);
          this.loading=false;
          if (data && data._id) {
              await this.getSettings();
              alert(this.$t('setting_updated'), "success");
          }else alert(data, "warning");
    },
    async getSettings() {
        window.history.replaceState({}, '', location.pathname);
        this.loading=true;
        const {content:data} = await this.$server.get("settings");
        const {content:dataWahrhouse} = await this.$server.get("settings",{warehouse:this.idWharhouse._id});
        await this.getRoles();
        this.loading=false; 

        this.formData._id=data._id;
        this.formData.details=data.details;
        this.formData.employers=[];

        const currentSettingW= this.getElementInArray(dataWahrhouse[0].details,this.idWharhouse._id);
        this.formData.detail = currentSettingW;
        

        if(!this.formData.detail.salaries) this.formData.detail.salaries=[];
        else {
          this.defaultTabHash='tab_'+this.formData.detail.salaries[0].type;
          location.hash = "#" + this.defaultTabHash;
        }
        this.formData.employers = this.formData.detail.salaries.map(el => el.type);
        
       
        
    },
  },
};
</script>

<style scoped>
.tag-rail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}
.rail-container {
  overflow: hidden;
  height: 36px;
  padding-top: 6px;
  cursor: pointer;
  scroll-behavior: smooth;
}
.tag {
  background: #e3ebf7;
  border-radius: 8px;
  padding: 3px 8px 4px;
  margin: 5px 4px;
  color: #109d93;
  font-weight: 500;
  user-select: none;
  border: 1px solid #e3ebf7;
  transition-duration: 0.25s;
  white-space: nowrap;
  border: 2px dashed #067d75;
}
.tag:first-child {
  margin-left: 16px;
}
.tag:last-child {
  margin-right: 16px;
}
.tag:hover {
  background: #dce4f0;
}
.tag:active {
  background: #e3ebf7;
}
.tag-selected {
  background: #3b71ca;
  color: #fff;
  border: 1px solid #3b71ca;
}
.tag-selected:hover {
  background: #3265b9;
  color: #fff;
}
.tag-selected:active {
  background: #3b71ca;
  color: #fff;
}
[class*="toggle__dot-"] {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ [class*="toggle__dot-"] {
  transform: translateX(100%);
  background-color: #63b3ed;
}
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}
.flex-imp {
    display: flex !important;
}
input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
.hori-center{
  display: flex;
    justify-content: center;
    align-items: center;
}
.vs-chip--close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 0;
    margin: 0 4px;
    margin-left: 8px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.15);
    color: #fff;
    transition: all 0.3s ease;
}
.vs-chip--close:after {
    content: "x";
    padding: 0px 2px;
    margin-bottom: 3px;
    font-size: 15px;
}
.whitespace-nowrap{
  	white-space: nowrap;
}
.max-height-200{
  max-height: 200px;
}
.max-height-300{
  max-height: 300px;
}
.tag_cities{
  max-height: 19vh;
  overflow-y: scroll;
}
/* total width */
.tag_cities::-webkit-scrollbar {
    width:7px
}


/* scrollbar itself */
.tag_cities::-webkit-scrollbar-thumb {
    background-color:#babac0;
    border-radius:16px;
}
.dtag_cities::-webkit-scrollbar-thumb:hover {
    background-color:#a0a0a5;
    border:4px solid #f4f4f4
}

/* set button(top and bottom of the scrollbar) */
.dropdown_warhouse::-webkit-scrollbar-button {display:none}
</style>